unit View.Fs_Prod_Caracteristicas.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls,
  UHelperServer, UUtils, UWeb.Enum;

type
  TFViewFs_Prod_CaracteristicasEdit = class(TForm)
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbslug: TLabel;
    edslug: TDBEdit;
    lbtipo: TLabel;
    edtipo: TDBEdit;
    lbexcluido: TLabel;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientFs_Prod_CaracteristicasGet: TXDataWebClient;
    Fs_Prod_CaracteristicasDataset: TXDataWebDataSet;
    Fs_Prod_CaracteristicasDatasetid: TIntegerField;
    Fs_Prod_CaracteristicasDatasetslug: TStringField;
    Fs_Prod_CaracteristicasDatasettipo: TStringField;
    Fs_Prod_CaracteristicasDatasetexcluido: TBooleanField;
    Fs_Prod_CaracteristicasDatasetinclusao: TDateTimeField;
    Fs_Prod_CaracteristicasDatasetalteracao: TDateTimeField;
    Fs_Prod_CaracteristicasDatasetexclusao: TDateTimeField;
    cbExcluido: TDBCheckBox;
    procedure btCancelClick(Sender: TObject);
    [async]
    procedure btSaveClick(Sender: TObject); async;
    procedure XDataClientFs_Prod_CaracteristicasGetLoad(Response: TXDataClientResponse);
    procedure Fs_Prod_CaracteristicasDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormShow(Sender: TObject);
    procedure edslugClick(Sender: TObject);
    procedure edtipoClick(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewFs_Prod_CaracteristicasEdit: TFViewFs_Prod_CaracteristicasEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewFs_Prod_CaracteristicasEdit }

procedure TFViewFs_Prod_CaracteristicasEdit.btSaveClick(Sender: TObject);
begin
  if THelperServer.VerificarCampoVazio(edslug) then
  begin
    TUtils.SetErroClass('lbslug', 'Preencha o slug!');
    Exit;
  end;

  if THelperServer.VerificarCampoVazio(edtipo) then
  begin
    TUtils.SetErroClass('lbtipo', 'Preencha o tipo!');
    Exit;
  end;

  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, THelperServer.GetMensagemPadraoSalvar(FInserting))) then
  begin
    if Fs_Prod_CaracteristicasDataset.State in dsEditModes then
    begin
          Fs_Prod_CaracteristicasDataset.Post;
      Fs_Prod_CaracteristicasDataset.ApplyUpdates;
    end
    else
      FShowListProc;
  end;
end;


class function TFViewFs_Prod_CaracteristicasEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewFs_Prod_CaracteristicasEdit.edslugClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('lbslug');
end;

procedure TFViewFs_Prod_CaracteristicasEdit.edtipoClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('lbtipo');
end;

procedure TFViewFs_Prod_CaracteristicasEdit.InsertEntity;
begin
  Fs_Prod_CaracteristicasDataset.Close;
  Fs_Prod_CaracteristicasDataset.SetJsonData('{}');
  Fs_Prod_CaracteristicasDataset.Open;
  Fs_Prod_CaracteristicasDataset.Insert;
end;

class function TFViewFs_Prod_CaracteristicasEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewFs_Prod_CaracteristicasEdit(AForm).FInserting := AInserting;
    TFViewFs_Prod_CaracteristicasEdit(AForm).FId := AId;
    TFViewFs_Prod_CaracteristicasEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewFs_Prod_CaracteristicasEdit(AForm).InsertEntity
    else
      TFViewFs_Prod_CaracteristicasEdit(AForm).LoadEntity;
  end;

begin
  Application.CreateForm(TFViewFs_Prod_CaracteristicasEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewFs_Prod_CaracteristicasEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    Fs_Prod_CaracteristicasDataset.Connection.Model.DefaultSchema.FindEntityType(
      Fs_Prod_CaracteristicasDataset.EntitySetName
    )
  );
  XDataClientFs_Prod_CaracteristicasGet.Get(Fs_Prod_CaracteristicasDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewFs_Prod_CaracteristicasEdit.WebFormShow(Sender: TObject);
begin
  if FInserting then
    THelperServer.RemoverDiv('campos-controle')
  else
  begin
    if not TUtils.PossuiPermissao(Fs_Prod_CaracteristicasDataset.EntitySetName.ToLower, TTipoPermissao.ALTERAR) then
    begin
      btSave.Enabled := False;
      edslug.Enabled := False;
      edtipo.Enabled := False;
      cbExcluido.Enabled := False;
    end;
  end;
end;

procedure TFViewFs_Prod_CaracteristicasEdit.XDataClientFs_Prod_CaracteristicasGetLoad(Response: TXDataClientResponse);
begin
  Fs_Prod_CaracteristicasDataset.Close;
  Fs_Prod_CaracteristicasDataset.SetJsonData(Response.Result);
  Fs_Prod_CaracteristicasDataset.Open;
  
  Fs_Prod_CaracteristicasDataset.Edit;  
end;

procedure TFViewFs_Prod_CaracteristicasEdit.Fs_Prod_CaracteristicasDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, ResolveInfo.Error);
      Fs_Prod_CaracteristicasDataset.Edit;
      Exit;
    end;
  end;

  TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, THelperServer.GetMensagemPadraoSalvarSucesso(FInserting));
  FShowListProc;
end;

procedure TFViewFs_Prod_CaracteristicasEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewFs_Prod_CaracteristicasEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbid := TLabel.Create('view.fs_prod_caracteristicas.form.lbid');
  lbslug := TLabel.Create('view.fs_prod_caracteristicas.form.lbslug');
  lbtipo := TLabel.Create('view.fs_prod_caracteristicas.form.lbtipo');
  lbexcluido := TLabel.Create('view.fs_prod_caracteristicas.form.lbexcluido');
  lbinclusao := TLabel.Create('view.fs_prod_caracteristicas.form.lbinclusao');
  lbalteracao := TLabel.Create('view.fs_prod_caracteristicas.form.lbalteracao');
  lbexclusao := TLabel.Create('view.fs_prod_caracteristicas.form.lbexclusao');
  btCancel := TButton.Create('view.fs_prod_caracteristicas.form.btBack');
  btSave := TButton.Create('view.fs_prod_caracteristicas.form.btSave');
  edid := TDBEdit.Create('view.fs_prod_caracteristicas.form.edid');
  edslug := TDBEdit.Create('view.fs_prod_caracteristicas.form.edslug');
  edtipo := TDBEdit.Create('view.fs_prod_caracteristicas.form.edtipo');
  edinclusao := TDBEdit.Create('view.fs_prod_caracteristicas.form.edinclusao');
  edalteracao := TDBEdit.Create('view.fs_prod_caracteristicas.form.edalteracao');
  edexclusao := TDBEdit.Create('view.fs_prod_caracteristicas.form.edexclusao');
  cbExcluido := TDBCheckBox.Create('view.fs_prod_caracteristicas.form.cbexcluido');
  DataSource := TDataSource.Create(Self);
  Fs_Prod_CaracteristicasDataset := TXDataWebDataSet.Create(Self);
  Fs_Prod_CaracteristicasDatasetid := TIntegerField.Create(Self);
  Fs_Prod_CaracteristicasDatasetslug := TStringField.Create(Self);
  Fs_Prod_CaracteristicasDatasettipo := TStringField.Create(Self);
  Fs_Prod_CaracteristicasDatasetexcluido := TBooleanField.Create(Self);
  Fs_Prod_CaracteristicasDatasetinclusao := TDateTimeField.Create(Self);
  Fs_Prod_CaracteristicasDatasetalteracao := TDateTimeField.Create(Self);
  Fs_Prod_CaracteristicasDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientFs_Prod_CaracteristicasGet := TXDataWebClient.Create(Self);

  lbid.BeforeLoadDFMValues;
  lbslug.BeforeLoadDFMValues;
  lbtipo.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  edslug.BeforeLoadDFMValues;
  edtipo.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  cbExcluido.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  Fs_Prod_CaracteristicasDataset.BeforeLoadDFMValues;
  Fs_Prod_CaracteristicasDatasetid.BeforeLoadDFMValues;
  Fs_Prod_CaracteristicasDatasetslug.BeforeLoadDFMValues;
  Fs_Prod_CaracteristicasDatasettipo.BeforeLoadDFMValues;
  Fs_Prod_CaracteristicasDatasetexcluido.BeforeLoadDFMValues;
  Fs_Prod_CaracteristicasDatasetinclusao.BeforeLoadDFMValues;
  Fs_Prod_CaracteristicasDatasetalteracao.BeforeLoadDFMValues;
  Fs_Prod_CaracteristicasDatasetexclusao.BeforeLoadDFMValues;
  XDataClientFs_Prod_CaracteristicasGet.BeforeLoadDFMValues;
  try
    Name := 'FViewFs_Prod_CaracteristicasEdit';
    Width := 593;
    Height := 454;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 23;
    lbid.Height := 13;
    lbid.Caption := 'C'#243'd:';
    lbid.HeightPercent := 100.000000000000000000;
    lbid.WidthPercent := 100.000000000000000000;
    lbslug.SetParentComponent(Self);
    lbslug.Name := 'lbslug';
    lbslug.Left := 24;
    lbslug.Top := 219;
    lbslug.Width := 24;
    lbslug.Height := 13;
    lbslug.Caption := 'Slug:';
    lbslug.HeightPercent := 100.000000000000000000;
    lbslug.WidthPercent := 100.000000000000000000;
    lbtipo.SetParentComponent(Self);
    lbtipo.Name := 'lbtipo';
    lbtipo.Left := 24;
    lbtipo.Top := 246;
    lbtipo.Width := 24;
    lbtipo.Height := 13;
    lbtipo.Caption := 'Tipo:';
    lbtipo.HeightPercent := 100.000000000000000000;
    lbtipo.WidthPercent := 100.000000000000000000;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 273;
    lbexcluido.Width := 43;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'Exclu'#237'do:';
    lbexcluido.HeightPercent := 100.000000000000000000;
    lbexcluido.WidthPercent := 100.000000000000000000;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 300;
    lbinclusao.Width := 44;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'Inclus'#227'o:';
    lbinclusao.HeightPercent := 100.000000000000000000;
    lbinclusao.WidthPercent := 100.000000000000000000;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 327;
    lbalteracao.Width := 50;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'Altera'#231#227'o:';
    lbalteracao.HeightPercent := 100.000000000000000000;
    lbalteracao.WidthPercent := 100.000000000000000000;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 354;
    lbexclusao.Width := 46;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'Exclus'#227'o:';
    lbexclusao.HeightPercent := 100.000000000000000000;
    lbexclusao.WidthPercent := 100.000000000000000000;
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 394;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancelar';
    btCancel.HeightPercent := 100.000000000000000000;
    btCancel.TabOrder := 1;
    btCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 394;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Salvar';
    btSave.HeightPercent := 100.000000000000000000;
    btSave.TabOrder := 4;
    btSave.WidthPercent := 100.000000000000000000;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := False;
    edid.HeightPercent := 100.000000000000000000;
    edid.TabOrder := 5;
    edid.Text := 'edid';
    edid.WidthPercent := 100.000000000000000000;
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    edslug.SetParentComponent(Self);
    edslug.Name := 'edslug';
    edslug.Left := 221;
    edslug.Top := 216;
    edslug.Width := 200;
    edslug.Height := 21;
    edslug.HeightPercent := 100.000000000000000000;
    edslug.MaxLength := 255;
    edslug.TabOrder := 6;
    edslug.Text := 'edslug';
    edslug.WidthPercent := 100.000000000000000000;
    SetEvent(edslug, Self, 'OnClick', 'edslugClick');
    edslug.DataField := 'slug';
    edslug.DataSource := DataSource;
    edtipo.SetParentComponent(Self);
    edtipo.Name := 'edtipo';
    edtipo.Left := 221;
    edtipo.Top := 243;
    edtipo.Width := 200;
    edtipo.Height := 21;
    edtipo.HeightPercent := 100.000000000000000000;
    edtipo.MaxLength := 255;
    edtipo.TabOrder := 7;
    edtipo.Text := 'edtipo';
    edtipo.WidthPercent := 100.000000000000000000;
    SetEvent(edtipo, Self, 'OnClick', 'edtipoClick');
    edtipo.DataField := 'tipo';
    edtipo.DataSource := DataSource;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 297;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := False;
    edinclusao.HeightPercent := 100.000000000000000000;
    edinclusao.TabOrder := 9;
    edinclusao.Text := 'edinclusao';
    edinclusao.WidthPercent := 100.000000000000000000;
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 324;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := False;
    edalteracao.HeightPercent := 100.000000000000000000;
    edalteracao.TabOrder := 10;
    edalteracao.Text := 'edalteracao';
    edalteracao.WidthPercent := 100.000000000000000000;
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 351;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := False;
    edexclusao.HeightPercent := 100.000000000000000000;
    edexclusao.TabOrder := 11;
    edexclusao.Text := 'edexclusao';
    edexclusao.WidthPercent := 100.000000000000000000;
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    cbExcluido.SetParentComponent(Self);
    cbExcluido.Name := 'cbExcluido';
    cbExcluido.Left := 221;
    cbExcluido.Top := 270;
    cbExcluido.Width := 113;
    cbExcluido.Height := 22;
    cbExcluido.Caption := 'cbExcluido';
    cbExcluido.ChildOrder := 13;
    cbExcluido.HeightPercent := 100.000000000000000000;
    cbExcluido.WidthPercent := 100.000000000000000000;
    cbExcluido.DataField := 'excluido';
    cbExcluido.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := Fs_Prod_CaracteristicasDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    Fs_Prod_CaracteristicasDataset.SetParentComponent(Self);
    Fs_Prod_CaracteristicasDataset.Name := 'Fs_Prod_CaracteristicasDataset';
    Fs_Prod_CaracteristicasDataset.AfterApplyUpdates := Fs_Prod_CaracteristicasDatasetAfterApplyUpdates;
    Fs_Prod_CaracteristicasDataset.EntitySetName := 'Fs_Prod_Caracteristicas';
    Fs_Prod_CaracteristicasDataset.Connection := DMConnection.ApiConnection;
    Fs_Prod_CaracteristicasDataset.Left := 176;
    Fs_Prod_CaracteristicasDataset.Top := 8;
    Fs_Prod_CaracteristicasDatasetid.SetParentComponent(Fs_Prod_CaracteristicasDataset);
    Fs_Prod_CaracteristicasDatasetid.Name := 'Fs_Prod_CaracteristicasDatasetid';
    Fs_Prod_CaracteristicasDatasetid.FieldName := 'id';
    Fs_Prod_CaracteristicasDatasetslug.SetParentComponent(Fs_Prod_CaracteristicasDataset);
    Fs_Prod_CaracteristicasDatasetslug.Name := 'Fs_Prod_CaracteristicasDatasetslug';
    Fs_Prod_CaracteristicasDatasetslug.FieldName := 'slug';
    Fs_Prod_CaracteristicasDatasetslug.Required := True;
    Fs_Prod_CaracteristicasDatasetslug.Size := 255;
    Fs_Prod_CaracteristicasDatasettipo.SetParentComponent(Fs_Prod_CaracteristicasDataset);
    Fs_Prod_CaracteristicasDatasettipo.Name := 'Fs_Prod_CaracteristicasDatasettipo';
    Fs_Prod_CaracteristicasDatasettipo.FieldName := 'tipo';
    Fs_Prod_CaracteristicasDatasettipo.Required := True;
    Fs_Prod_CaracteristicasDatasettipo.Size := 255;
    Fs_Prod_CaracteristicasDatasetexcluido.SetParentComponent(Fs_Prod_CaracteristicasDataset);
    Fs_Prod_CaracteristicasDatasetexcluido.Name := 'Fs_Prod_CaracteristicasDatasetexcluido';
    Fs_Prod_CaracteristicasDatasetexcluido.FieldName := 'excluido';
    Fs_Prod_CaracteristicasDatasetinclusao.SetParentComponent(Fs_Prod_CaracteristicasDataset);
    Fs_Prod_CaracteristicasDatasetinclusao.Name := 'Fs_Prod_CaracteristicasDatasetinclusao';
    Fs_Prod_CaracteristicasDatasetinclusao.FieldName := 'inclusao';
    Fs_Prod_CaracteristicasDatasetinclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Fs_Prod_CaracteristicasDatasetalteracao.SetParentComponent(Fs_Prod_CaracteristicasDataset);
    Fs_Prod_CaracteristicasDatasetalteracao.Name := 'Fs_Prod_CaracteristicasDatasetalteracao';
    Fs_Prod_CaracteristicasDatasetalteracao.FieldName := 'alteracao';
    Fs_Prod_CaracteristicasDatasetalteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Fs_Prod_CaracteristicasDatasetexclusao.SetParentComponent(Fs_Prod_CaracteristicasDataset);
    Fs_Prod_CaracteristicasDatasetexclusao.Name := 'Fs_Prod_CaracteristicasDatasetexclusao';
    Fs_Prod_CaracteristicasDatasetexclusao.FieldName := 'exclusao';
    Fs_Prod_CaracteristicasDatasetexclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    XDataClientFs_Prod_CaracteristicasGet.SetParentComponent(Self);
    XDataClientFs_Prod_CaracteristicasGet.Name := 'XDataClientFs_Prod_CaracteristicasGet';
    XDataClientFs_Prod_CaracteristicasGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientFs_Prod_CaracteristicasGet, Self, 'OnLoad', 'XDataClientFs_Prod_CaracteristicasGetLoad');
    XDataClientFs_Prod_CaracteristicasGet.Left := 64;
    XDataClientFs_Prod_CaracteristicasGet.Top := 8;
  finally
    lbid.AfterLoadDFMValues;
    lbslug.AfterLoadDFMValues;
    lbtipo.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    edslug.AfterLoadDFMValues;
    edtipo.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    cbExcluido.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    Fs_Prod_CaracteristicasDataset.AfterLoadDFMValues;
    Fs_Prod_CaracteristicasDatasetid.AfterLoadDFMValues;
    Fs_Prod_CaracteristicasDatasetslug.AfterLoadDFMValues;
    Fs_Prod_CaracteristicasDatasettipo.AfterLoadDFMValues;
    Fs_Prod_CaracteristicasDatasetexcluido.AfterLoadDFMValues;
    Fs_Prod_CaracteristicasDatasetinclusao.AfterLoadDFMValues;
    Fs_Prod_CaracteristicasDatasetalteracao.AfterLoadDFMValues;
    Fs_Prod_CaracteristicasDatasetexclusao.AfterLoadDFMValues;
    XDataClientFs_Prod_CaracteristicasGet.AfterLoadDFMValues;
  end;
end;

end.
